import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse} from '../../../../shared/models/ApiModels'
import {IHrProcessStepModel} from './HrProcessStepModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const HR_PROCESS_STEP_CREATE_URL = `${API_URL}api/v1/hrprocessstep/create`
export const HR_PROCESS_STEP_BY_PROCESS_URL = `${API_URL}api/v1/hrprocessstep/getByHrProcessId/`
export const HR_PROCESS_STEP_UPDATE_URL = `${API_URL}api/v1/hrprocessstep/update/`
export const HR_PROCESS_STEP_DELETE_URL = `${API_URL}api/v1/hrprocessstep/delete/`

/** Sürecin tüm adımları (düz liste) */
export function loadHrProcessSteps(
  hrProcessId: string
): Promise<AxiosResponse<ApiResponse<IHrProcessStepModel[]>>> {
  return corporateApi.get(HR_PROCESS_STEP_BY_PROCESS_URL + hrProcessId)
}

export function createHrProcessStep(
  step: IHrProcessStepModel
): Promise<AxiosResponse<ApiResponse<IHrProcessStepModel>>> {
  return corporateApi.post(HR_PROCESS_STEP_CREATE_URL, step)
}

export function updateHrProcessStep(
  step: IHrProcessStepModel
): Promise<AxiosResponse<ApiResponse<IHrProcessStepModel>>> {
  return corporateApi.patch(HR_PROCESS_STEP_UPDATE_URL + step.id, step)
}

export function deleteHrProcessStep(stepId: string) {
  return corporateApi.delete(HR_PROCESS_STEP_DELETE_URL + stepId)
}
